import Icon from "@amzn/meridian/icon";
import { ReactNode } from "react";

export type ChipTone =
  | "neutral"
  | "blue"
  | "green"
  | "amber"
  | "red"
  | "purple"
  | "teal";

interface ChipProps {
  children: ReactNode;
  tone?: ChipTone;
  /** Meridian icon tokens rendered before the label. */
  tokens?: any;
  /** Renders a filled status dot before the label. */
  dot?: boolean;
  /** Inverts the tone, for the high-emphasis region chip. */
  solid?: boolean;
  monospace?: boolean;
}

const Chip = ({
  children,
  tone = "neutral",
  tokens,
  dot,
  solid,
  monospace,
}: ChipProps) => {
  const classNames = [
    "admin-report__chip",
    `admin-report__chip--${tone}${solid ? "-solid" : ""}`,
    monospace ? "admin-report__chip--monospace" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <span className={classNames}>
      {dot && <span className="admin-report__chip-dot" />}
      {tokens && <Icon tokens={tokens} />}
      {children}
    </span>
  );
};

export default Chip;
